/** @format */
import jQuery from 'jquery';
import select2 from 'select2';
select2(jQuery);

document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById('poem-search-form')
    if (form) {
        form.addEventListener('submit', event => {
            event.preventDefault()

            const data = new FormData(event.target)
            let dataObject = Object.fromEntries(data.entries())

            const action = new URL(event.target.action)

            // Filter out empty values
            dataObject = Object.fromEntries(Object.entries(dataObject).filter(([_, v]) => v.length > 0));
            for (const [key, value] of Object.entries(dataObject)) {
                action.searchParams.set(key, value)
            }
            action.searchParams.delete('poem-topic')

            window.location.href = action.href

        })
    }

})


jQuery(function($) {

    $('.c-npl-header .select2-field').select2({
        dropdownParent: $('.c-npl-header__filter-bar')
    });

    $('.c-npl-header .select2-field').on('select2:select', function (e) {
        if($(this).val()) {
            window.location.href = $(this).val();
        }
    });

});
